import React from 'react';
import { Image, ImageStyle, StyleProp } from 'react-native';

interface EditIconProps {
  size?: number;
  style?: StyleProp<ImageStyle>;
}

const EditIcon: React.FC<EditIconProps> = ({ size = 42, style }) => {
  return (
    <Image
      source={require('@/assets/images/Edit.png')}
      style={[{ width: size, height: size }, style]}
    />
  );
};

export default EditIcon;
